<template>
  <v-container class="white" grid-list-xl fluid ma-0 pa-0>
    <v-layout justify-center wrap class="white lighten-4 pa-1 caption">     
      <v-flex xs12 md6>
        <material-card color="indigo" title="Registration Form">
          <v-form ref="form" class="pa-1" v-model="valid" lazy-validation>
            <v-container py-0>
              <v-layout wrap>
                <v-flex xs12  md12>
                <v-avatar slot="offset" class="mx-auto d-block" size="150">
                <v-img class="white--text align-end" :src="require(`@/assets/thiruvalluvar.png`)" width="130"> </v-img><br>
                <div class="caption" style="color: #8ebf42">Membership Form</div>
                </v-avatar><br>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field ref="Json.firstname" v-on:keyup="handleInputOnKeyup" :rules="nameRules" class="caption" dense background-color="white lighten-5" required v-model="Json.firstname" filled outlined  placeholder=" " label="FirstName"></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field ref="Json.lastname" v-on:keyup="handleInputOnKeyup" :rules="nameRules" class="caption" dense background-color="white lighten-5" required v-model="Json.lastname" filled outlined   placeholder=" " label="LastName"></v-text-field>
                </v-flex>
                <v-flex xs12 md7>
                  <v-text-field ref="Json.primaryemail" v-on:keyup="handleInputOnKeyup" required class="caption" :rules="emailRules" dense background-color="white lighten-5" v-model="Json.primaryemail" filled outlined  placeholder=" " label="Email"></v-text-field>
                </v-flex>
                <v-flex xs12 md5>
                  <v-text-field ref="Json.mobile" :rules="phoneRules" dense background-color="white lighten-5" required v-model="Json.mobile" outlined filled  class="caption" placeholder=" " label="Mobile"></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field ref="Json.address" class="caption" dense background-color="white lighten-5" required v-model="Json.address" filled outlined   placeholder=" " label="Address"></v-text-field>
                </v-flex>
                <v-flex xs12 md3>
                   <v-Select ref="Json.state" class="caption" dense background-color="white lighten-5" required :items="['NC', 'SC']" v-model="Json.state" filled outlined   placeholder=" " label="State"></v-Select>
                </v-flex>
                <v-flex xs12 md3>
                  <v-text-field ref="Json.city" class="caption" dense background-color="white lighten-5" required v-model="Json.city" filled outlined   placeholder=" " label="City"></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-Select ref="Json.membershipcategory" dense background-color="white lighten-5" required v-model="Json.membershipcategory" :items="['Paarivallal', 'Family', 'Single']" outlined class="caption"  placeholder=" " label="Membership Category"></v-Select>
                </v-flex>
                 <v-flex xs12 md4>
                  <v-text-field  ref="Json.paymentstatus" dense background-color="white lighten-5" required v-model="Json.paymentstatus" disabled outlined class="caption"  placeholder=" " label="Payment Status"></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-Select ref="Json.year" dense background-color="white lighten-5" required v-model="Json.year" :items="['2025', '2024','2023','2022', '2021', '2020']" outlined disabled class="caption"  placeholder=" " label="Year"></v-Select>
                </v-flex>
                <v-flex xs12 md4>
                    <v-btn :disabled="!valid" :loading="isLoading" class="white--text" color="primary caption" medium depressed @click='submit()'>
                      <v-icon left xs-small>mdi-floppy</v-icon>Submit
                    </v-btn>
                </v-flex><br>
                <v-alert v-if="errorMessage===true" dismissible outlined dark class="caption red" dense>Membership already exist with tamilsangam</v-alert>
                   <div class="caption" style="color: #8ebf42">** Only Primary Member need to fill this form.</div>
              </v-layout>
            </v-container>
          </v-form>
        </material-card>
      </v-flex>
      <v-flex xs12 md6>
          <v-card class="caption pa-0 elevation-0" style="max-width: 100%">
              <b>New members </b>: <br>
              1. Register Membership <br> 
              2. Create account (sign up).<br> 
              3. Update your profile.<br> 
              4. Pay your membership due.<br> 
              5. Manage your membership online.<br> <br> 
              <b>Newly accessing existing members  </b>:<br>
              1. Sign in with your primary email address that you used to pay membership fee, and the password that was sent to your email address. 
              If you have not received or lost the password , request for a reset 
              (through Forgot password link in the sign in page).<br>
              2. Update your profile.<br>
              3. Manage your membership online.<br> <br> 
          <p> All memberships are for a period of one year. Starts from Jan 1 - Dec 31 of the current year. </p>
          <p> <b>Paari vallal - $80/year </b>: A highly donated family membership, who enjoy all the benefits of Tamil Sangam. </p>
          <p> <b>Family -  $50/year </b>: A family membership shall be open to any family. A family is defined as husband, wife, dependent children and dependent parents. </p>
          <p> <b>Single - $25/year </b>: Single membership shall be open to any person/youth between ages 18 and 25 years with Valid ID. </p>
          <p><b>Membership upgrade</b></p>
          <p>Already paid your membership for the year and want to pay $30 and upgrade to Parivallal ? login and go to your profile page to upgrade.  </p>
          <p> Once paid, you will be upgraded Paarivallal level automatically.</p> 
        </v-card>
      </v-flex>
      <v-flex xs12 md12>
		<extended-footer></extended-footer>
	</v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import ReportServices from '@/services/ReportServices'
import ExtendedFooter from '@/components/Footer'

  export default {
    data: () => ({
      errorMessage: false,
      valid: true,
      name: '',
      nameRules: [
        v => !!v || 'Name is required',
        v => (v && v.length <= 25) || 'Name must be less than 25 characters',
      ],
      phoneRules: [
        v => !!v || 'Ph is required',
        v => (v && v.length <= 10) || 'Number must be less than 11 characters',
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      form: false,
      Json: {
        _id: '',
        firstname: '',
        lastname: '',
        primaryemail: '',
        mobile: '',
        address: '',
        state: '',
        city: '',
        membershipcategory: '',
        paymentstatus: 'Not Paid',
        year: '2025',
        secondaryEmail: ''
      },
    }),
    components: {
      ExtendedFooter
      },
    methods: {
    handleInputOnKeyup() {
      this.Json.primaryemail = this.Json.primaryemail.toLowerCase().trim()
      this.Json.secondaryEmail = this.Json.secondaryEmail.toLowerCase().trim()
      this.Json.firstname = this.Json.firstname.toLowerCase().trim()
      this.Json.lastname = this.Json.lastname.toLowerCase().trim()
    },
    async submit () {
      if (this.$refs.form.validate()) {
        const response = await ReportServices.addmembership(this.Json)
        if (response.status == 202) {
          this.errorMessage = true
        } else {
          setTimeout(() => {
            this.$router.push('/ThankYou')
          }, 200)
        }
      }
    }
  }
}
</script>

<style>
ul {
  list-style-type: square;
}
.v-card__title {
  font-style: italic;
}
.v-card__text {
  color: rgb(215, 223, 223)!important;
}
</style>